var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import { ThemeProvider } from 'styled-components';
import styled from '../utils/styled-components';
import badgeTheme from './theme';
var PillBadge = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: ", ";\n  border: ", ";\n  border-radius: 2em;\n  color: ", ";\n  height: 2em;\n  padding: 0.3em 0.6em;\n  font-size: ", ";\n"], ["\n  background: ",
    ";\n  border: ",
    ";\n  border-radius: 2em;\n  color: ",
    ";\n  height: 2em;\n  padding: 0.3em 0.6em;\n  font-size: ",
    ";\n"])), function (_a) {
    var component = _a.theme.component, _b = _a.variant, variant = _b === void 0 ? 'greyscale' : _b;
    return component.badge.background[variant];
}, function (_a) {
    var component = _a.theme.component, _b = _a.variant, variant = _b === void 0 ? 'greyscale' : _b;
    return component.badge.border[variant];
}, function (_a) {
    var component = _a.theme.component, _b = _a.variant, variant = _b === void 0 ? 'greyscale' : _b;
    return component.badge.text[variant];
}, function (_a) {
    var component = _a.theme.component, _b = _a.size, size = _b === void 0 ? 'medium' : _b;
    return component.badge.fontSize[size];
});
var LabelBadge = styled(PillBadge)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  border-radius: ", ";\n"], ["\n  border-radius: ", ";\n"])), function (_a) {
    var component = _a.theme.component;
    return component.badge.borderRadius;
});
export var Badge = function (_a) {
    var className = _a.className, _b = _a.pill, pill = _b === void 0 ? false : _b, variant = _a.variant, size = _a.size, children = _a.children;
    return (React.createElement(ThemeProvider, { theme: badgeTheme }, pill ? (React.createElement(PillBadge, { variant: variant, size: size, className: className }, children)) : (React.createElement(LabelBadge, { variant: variant, size: size, className: className }, children))));
};
export default Badge;
var templateObject_1, templateObject_2;
//# sourceMappingURL=index.js.map